/**
 * @generated SignedSource<<6c1d29b5e4d7b770e428890d3cc58868>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreQuoteTitle_transaction$data = {
  readonly isFullPriceOrder: boolean | null;
  readonly isNegotiable: boolean | null;
  readonly isShippingKnownAtCheckout: boolean | null;
  readonly leadTime: {
    readonly value: string | null;
  } | null;
  readonly sku: {
    readonly leadTime: string | null;
  } | null;
  readonly " $fragmentType": "PreQuoteTitle_transaction";
};
export type PreQuoteTitle_transaction$key = {
  readonly " $data"?: PreQuoteTitle_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreQuoteTitle_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreQuoteTitle_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFullPriceOrder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNegotiable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isShippingKnownAtCheckout",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "sku",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "pageType",
              "value": "Checkout"
            }
          ],
          "kind": "ScalarField",
          "name": "leadTime",
          "storageKey": "leadTime(pageType:\"Checkout\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TransactionLeadTime",
      "kind": "LinkedField",
      "name": "leadTime",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "54cd2ba6132f4d4b7e137fd6b772c990";

export default node;
